import script from "./ImageAudio.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageAudio.vue?vue&type=script&setup=true&lang=js"

import "./ImageAudio.vue?vue&type=style&index=0&id=21ce1eff&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ce1eff"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
